import React, { useState, useEffect, useReducer } from 'react';
import { default as ContractNew } from './ContractNew';

import {
  Tabs,
  Row, Col,
  Divider,
  Badge,
  Button,
  Form, Input, Select, DatePicker, InputNumber, Dropdown,
  Space,
  Progress, Popover
} from 'antd';
import './style';

export default React.forwardRef((props, ref) => {
  const { suppliers, contract, onSaveCallback } = props;
  const { TabPane } = Tabs;
  return (
    <Tabs size="small" style={{ padding: '1rem 0' }} onChange={null} type="card">
      <TabPane tab="① 合同信息" key="1">
        <ContractNew contract={contract} onSaveCallback={onSaveCallback} suppliers={suppliers} mode="edit" />
      </TabPane>
      <TabPane tab="② 装箱单" key="2">

      </TabPane>
      <TabPane tab="③ 合同操作履历" key="4">
        第二期完成
      </TabPane>
    </Tabs>
  )
});
